(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('checkbox', function(arrayUtil, $timeout) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            model: '=',
            name: '@?',
            val: '=',
            disabled: '=',
            onToggle: '&', // Runs during init
            onClick: '&', // Runs only on click
            onInit: '&?', // Handles initialization logic
            templateVersion: '=',
            mandatory: '<?'
        },
        templateUrl: (element, attr) => {
            if (attr.templateVersion) {
                return `partials/booking/template?name=checkbox&version=${attr.templateVersion}`;
            }
            return 'partials/home/checkbox';
        },
        link(scope) {
            scope.toggle = function() {
                if (scope.disabled) { return; }
                if (Array.isArray(scope.model)) {
                    const index = indexOfVal(scope.model);
                    if (index > -1) {
                        scope.model.splice(index, 1);
                    } else {
                        scope.model.push(scope.val);
                    }
                } else {
                    scope.model = !scope.model;
                }
                $timeout(scope.onClick); // `model` not updated in parent context without $timeout
            };

            scope.$watchCollection('model', function(model) {
                if (model !== undefined) {
                    scope.checked = Array.isArray(model) ? indexOfVal(model) > -1 : model;
                    scope.onToggle();
                }
            });

            if (scope.onInit) {
                scope.onInit();
            }

            function indexOfVal(array) {
                return arrayUtil.indexOf(array, function(i) {
                    // Need angular.equals to compare { OptionId: "4":, Quantity: 1 } with { OptionId: "4":, Quantity: 1 }
                    return scope.val === String(i) || angular.equals(scope.val, i);
                });
            }
        }
    };
});
})();




